import { SvgIcon } from "@mui/material";
import type { SvgIconProps } from "@mui/material";

export const MooneIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 100 100" role="img" {...props}>
    <g transform="matrix(0.95337,0,0,0.956418,2.3315,2.17911)">
      <g transform="matrix(0.860258,0,0,0.860258,-400.308,-327.5)">
        <path
          d="M481.897,465.176C481.685,464.822 481.476,464.464 481.271,464.102C477.092,456.737 475.002,448.35 475.002,438.941C475.002,429.41 477.096,421.015 481.282,413.757C485.469,406.499 491.146,400.791 498.312,396.635C505.479,392.479 513.648,390.401 522.82,390.401C527.702,390.401 532.309,390.99 536.642,392.167C533.804,391.668 530.886,391.408 527.908,391.408C499.809,391.408 476.997,414.55 476.997,443.054C476.997,450.968 478.755,458.469 481.897,465.176Z"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(0.231982,0,0,0.231982,-194.944,-112.34)">
        <path
          d="M1102.94,540.953C1178.88,558.55 1235.56,626.682 1235.56,707.946C1235.56,802.55 1158.75,879.356 1064.15,879.356C987.634,879.356 922.761,829.113 900.752,759.851C928.357,793.39 970.174,814.785 1016.95,814.785C1099.97,814.785 1167.38,747.382 1167.38,664.359C1167.38,613.301 1141.88,568.15 1102.94,540.953Z"
          fill="currentColor"
        />
      </g>
    </g>
  </SvgIcon>
);
